import React, { useState } from 'react';
import { Link } from 'react-router-dom';


function FeedbackForm() {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [feedback, setFeedback] = useState('');
    const [name, setName] = useState('');
    const [submitted, setSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (rating === 0) return alert('Please select a star rating');
        try {
            await fetch('http://localhost:5000/api/dashboard/feedback', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, rating, message: feedback }),
            });
            setSubmitted(true);
        } catch (err) {
            alert('Feedback submit nahi hua. Dobara try karo.');
        }
    };

    if (submitted) {
        return (
            <div className="text-center py-12 bg-dark-300 border border-gray-800 rounded-3xl">
                <div className="text-6xl mb-4">🙏</div>
                <h3 className="font-display text-2xl font-bold text-white mb-2">शुक्रिया!</h3>
                <p className="text-gray-400">आपकी feedback हमें बेहतर बनाएगी।</p>
                <button
                    onClick={() => { setSubmitted(false); setRating(0); setFeedback(''); setName(''); }}
                    className="mt-4 text-saffron-500 text-sm underline"
                >
                    दूसरी feedback दो
                </button>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit} className="bg-dark-300 border border-gray-800 rounded-3xl p-8 flex flex-col gap-6">
            <div className="text-center">
                <p className="text-gray-400 text-sm mb-4">Rating दो *</p>
                <div className="flex justify-center gap-3">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <button
                            key={star}
                            type="button"
                            onClick={() => setRating(star)}
                            onMouseEnter={() => setHover(star)}
                            onMouseLeave={() => setHover(0)}
                            className="text-4xl transition-transform hover:scale-110"
                        >
                            <span className={star <= (hover || rating) ? 'text-saffron-500' : 'text-gray-700'}>★</span>
                        </button>
                    ))}
                </div>
                {rating > 0 && (
                    <p className="text-saffron-500 text-sm mt-2 font-medium">
                        {['', 'बहुत बुरा', 'ठीक है', 'अच्छा', 'बहुत अच्छा', 'एकदम बढ़िया! 🔥'][rating]}
                    </p>
                )}
            </div>

            <div>
                <label className="text-gray-400 text-sm mb-2 block">आपका नाम</label>
                <input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Rahul Kumar"
                    className="w-full bg-dark-200 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600"
                />
            </div>

            <div>
                <label className="text-gray-400 text-sm mb-2 block">आपका अनुभव लिखो</label>
                <textarea
                    rows={3}
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    placeholder="JobFreedom से मुझे बहुत help मिली..."
                    className="w-full bg-dark-200 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600 resize-none"
                />
            </div>

            <button
                type="submit"
                className="bg-saffron-500 hover:bg-saffron-600 text-white font-semibold py-4 rounded-full transition shadow-lg shadow-saffron-500/30"
            >
                Feedback Submit करो ✓
            </button>
        </form>
    );
}

function Home() {
    return (
        <main className="bg-dark-300 min-h-screen">

            {/* ── HERO SECTION ── */}
            <section className="relative max-w-7xl mx-auto px-4 pt-20 pb-24 text-center">
                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-saffron-500 opacity-10 rounded-full blur-3xl pointer-events-none" />

                <p className="text-saffron-500 font-semibold tracking-widest text-sm uppercase mb-4">
                    बिहार का नंबर 1 जॉब पोर्टल
                </p>

                <h1 className="font-display text-4xl md:text-6xl font-bold text-white leading-tight mb-6">
                    अपना सपना पूरा करो <br />
                    <span className="text-saffron-500">बिल्कुल Free में</span>
                </h1>

                <p className="text-gray-400 text-lg max-w-xl mx-auto mb-10">
                    10वीं, ITI और Diploma पास युवाओं के लिए बिहार की सबसे भरोसेमंद नौकरी सेवा।
                    एक बार रजिस्टर करो, जिंदगी भर फायदा उठाओ।
                </p>

                <Link
                    to="/form/10th"
                    className="inline-block bg-saffron-500 hover:bg-saffron-600 text-white text-lg font-semibold px-10 py-4 rounded-full transition shadow-lg shadow-saffron-500/30"
                >
                    अभी Apply करो — बिल्कुल Free!
                </Link>

                {/* Stats */}
                <div className="grid grid-cols-3 gap-4 max-w-2xl mx-auto mt-16">
                    {[
                        { number: '10,000+', label: 'Students Registered' },
                        { number: '500+', label: 'Companies Hiring' },
                        { number: 'Free', label: 'Registration' },
                    ].map((stat, i) => (
                        <div key={i} className="bg-dark-200 border border-gray-800 rounded-2xl p-4">
                            <div className="text-saffron-500 font-display text-xl md:text-3xl font-bold">{stat.number}</div>
                            <div className="text-gray-400 text-xs md:text-sm mt-1">{stat.label}</div>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── 3 CATEGORY CARDS ── */}
            <section className="max-w-7xl mx-auto px-4 pb-24">
                <h2 className="font-display text-3xl md:text-4xl font-bold text-white text-center mb-4">
                    अपनी Category चुनो
                </h2>
                <p className="text-gray-400 text-center mb-12">
                    नीचे अपनी qualification के हिसाब से category select करो
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

                    {/* 10th Card */}
                    <div className="group bg-dark-200 border border-gray-800 hover:border-saffron-500 rounded-3xl p-8 transition-all duration-300 hover:shadow-xl hover:shadow-saffron-500/10 cursor-pointer">
                        <div className="text-5xl mb-6">🎓</div>
                        <h3 className="font-display text-2xl font-bold text-white mb-3">10th / 12th / Graduation</h3>
                        <p className="text-gray-400 text-sm leading-relaxed mb-6">
                            मैट्रिक, इंटर या BA Graduation पास students के लिए factory, security, helper जैसी नौकरियां।
                        </p>
                        <ul className="text-gray-400 text-sm space-y-2 mb-8">
                            <li className="flex items-center gap-2"><span className="text-saffron-500">✓</span> Factory Jobs</li>
                            <li className="flex items-center gap-2"><span className="text-saffron-500">✓</span> Security Guard</li>
                            <li className="flex items-center gap-2"><span className="text-saffron-500">✓</span> Helper / Peon</li>
                            <li className="flex items-center gap-2"><span className="text-saffron-500">✓</span> Office Assistant</li>
                        </ul>
                        <Link to="/form/10th" className="block text-center bg-saffron-500 group-hover:bg-saffron-600 text-white font-semibold py-3 rounded-full transition">
                            Apply Now — Free!
                        </Link>
                    </div>

                    {/* ITI Card */}
                    <div className="group bg-dark-200 border border-saffron-500 rounded-3xl p-8 transition-all duration-300 hover:shadow-xl hover:shadow-saffron-500/20 cursor-pointer relative">
                        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-saffron-500 text-white text-xs font-bold px-4 py-1 rounded-full">
                            MOST POPULAR
                        </div>
                        <div className="text-5xl mb-6">🔧</div>
                        <h3 className="font-display text-2xl font-bold text-white mb-3">ITI Pass</h3>
                        <p className="text-gray-400 text-sm leading-relaxed mb-6">
                            ITI certificate holders के लिए skilled technician, electrician, welder जैसी jobs।
                        </p>
                        <ul className="text-gray-400 text-sm space-y-2 mb-8">
                            <li className="flex items-center gap-2"><span className="text-saffron-500">✓</span> Electrician</li>
                            <li className="flex items-center gap-2"><span className="text-saffron-500">✓</span> Welder / Fitter</li>
                            <li className="flex items-center gap-2"><span className="text-saffron-500">✓</span> Mechanic</li>
                        </ul>
                        <Link to="/form/iti" className="block text-center bg-saffron-500 hover:bg-saffron-600 text-white font-semibold py-3 rounded-full transition">
                            Apply Now — Free!
                        </Link>
                    </div>

                    {/* Diploma Card */}
                    <div className="group bg-dark-200 border border-gray-800 hover:border-saffron-500 rounded-3xl p-8 transition-all duration-300 hover:shadow-xl hover:shadow-saffron-500/10 cursor-pointer">
                        <div className="text-5xl mb-6">📐</div>
                        <h3 className="font-display text-2xl font-bold text-white mb-3">Diploma / B.Tech Pass</h3>
                        <p className="text-gray-400 text-sm leading-relaxed mb-6">
                            Diploma या B.Tech pass students के लिए supervisor, junior engineer, technician level की jobs।
                        </p>
                        <ul className="text-gray-400 text-sm space-y-2 mb-8">
                            <li className="flex items-center gap-2"><span className="text-saffron-500">✓</span> Junior Engineer</li>
                            <li className="flex items-center gap-2"><span className="text-saffron-500">✓</span> Supervisor</li>
                            <li className="flex items-center gap-2"><span className="text-saffron-500">✓</span> Quality Control</li>
                        </ul>
                        <Link to="/form/diploma" className="block text-center bg-saffron-500 group-hover:bg-saffron-600 text-white font-semibold py-3 rounded-full transition">
                            Apply Now — Free!
                        </Link>
                    </div>

                </div>
            </section>

            {/* ── HOW IT WORKS ── */}
            <section className="bg-dark-200 py-24">
                <div className="max-w-7xl mx-auto px-4">
                    <h2 className="font-display text-3xl md:text-4xl font-bold text-white text-center mb-16">
                        कैसे काम करता है?
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {[
                            { step: '01', title: 'Category चुनो', desc: '10th, ITI या Diploma — अपनी qualification select करो' },
                            { step: '02', title: 'Form भरो', desc: 'अपनी details भरो — 5 minute का काम' },
                            { step: '03', title: 'Job पाओ', desc: 'हमारे contractors सीधे तुमसे contact करेंगे' },
                        ].map((item, i) => (
                            <div key={i} className="text-center">
                                <div className="text-saffron-500 font-display text-5xl font-bold opacity-30 mb-2">{item.step}</div>
                                <h4 className="text-white font-semibold text-lg mb-2">{item.title}</h4>
                                <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ── TRUST SECTION ── */}
            <section className="max-w-7xl mx-auto px-4 py-24 text-center">
                <h2 className="font-display text-3xl font-bold text-white mb-4">
                    हम पर भरोसा क्यों करें?
                </h2>
                <p className="text-gray-400 mb-12">बिहार के हजारों युवाओं ने हमारे साथ अपना सफर शुरू किया</p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {[
                        { icon: '🔒', title: '100% Secure', desc: 'आपकी details पूरी तरह safe हैं' },
                        { icon: '⚡', title: 'Fast Process', desc: 'Form submit करो, 48 घंटे में contact' },
                        { icon: '💯', title: 'Verified Companies', desc: 'सभी contractors verified हैं' },
                    ].map((item, i) => (
                        <div key={i} className="bg-dark-200 border border-gray-800 rounded-2xl p-8">
                            <div className="text-4xl mb-4">{item.icon}</div>
                            <h4 className="text-white font-semibold text-lg mb-2">{item.title}</h4>
                            <p className="text-gray-400 text-sm">{item.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* ── FEEDBACK SECTION ── */}
            <section className="bg-dark-200 py-20">
                <div className="max-w-3xl mx-auto px-4">
                    <h2 className="font-display text-3xl font-bold text-white text-center mb-4">
                        आपका अनुभव कैसा रहा?
                    </h2>
                    <p className="text-gray-400 text-center mb-10">
                        हमें बताओ — आपकी feedback से हम बेहतर बनते हैं
                    </p>
                    <FeedbackForm />
                </div>
            </section>

        </main>
    );
}

export default Home;